import React from 'react';

export default function CTFHero({ ctfData }) {
    if (!ctfData) return null;
    return (
        <section className="ctf-hero">
            <style>{`
                .ctf-hero {
                    position: relative;
                    padding: 160px 0 100px;
                    background: var(--eventflow-black);
                    overflow: hidden;
                    text-align: center;
                }
                .ctf-hero::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background:
                        radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-primary-rgb),0.2) 0%, transparent 60%),
                        radial-gradient(ellipse at 20% 100%, rgba(var(--eventflow-base-rgb),0.1) 0%, transparent 50%);
                    pointer-events: none;
                }
                /* grid lines */
                .ctf-hero::after {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                }
                .ctf-hero__inner {
                    position: relative;
                    z-index: 2;
                }
                .ctf-hero__tag {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    color: var(--eventflow-base);
                    margin-bottom: 20px;
                }
                .ctf-hero__tag::before,
                .ctf-hero__tag::after {
                    content: '';
                    display: inline-block;
                    width: 32px; height: 1px;
                    background: var(--eventflow-base);
                    opacity: 0.5;
                }
                .ctf-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 72px;
                    font-weight: 900;
                    line-height: 1.0;
                    letter-spacing: -2px;
                    margin-bottom: 20px;
                }
                .ctf-hero__title span {
                    display: block;
                    background: linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.6) 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .ctf-hero__title .accent {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 50%, var(--eventflow-primary) 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .ctf-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 17px;
                    color: rgba(255,255,255,0.5);
                    max-width: 560px;
                    margin: 0 auto 44px;
                    line-height: 1.75;
                }
                /* stat pills */
                .ctf-hero__stats {
                    display: flex;
                    justify-content: center;
                    gap: 12px;
                    flex-wrap: wrap;
                }
                .ctf-hero__stat {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: rgba(255,255,255,0.04);
                    border: 1px solid rgba(255,255,255,0.08);
                    border-radius: 50px;
                    padding: 9px 20px;
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    color: rgba(255,255,255,0.55);
                    transition: border-color 0.3s, background 0.3s;
                }
                .ctf-hero__stat:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.35);
                    background: rgba(var(--eventflow-base-rgb),0.06);
                    color: #fff;
                }
                .ctf-hero__stat i { color: var(--eventflow-base); font-size: 13px; }
                .ctf-hero__stat strong { color: #fff; font-weight: 700; }

                @media (max-width: 768px) {
                    .ctf-hero { padding: 130px 0 70px; }
                    .ctf-hero__title { font-size: 48px; letter-spacing: -1px; }
                    .ctf-hero__stats { gap: 8px; }
                }
            `}</style>

            <div className="container">
                <div className="ctf-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="ctf-hero__tag">{ctfData.section.eyebrow}</div>
                    <h1 className="ctf-hero__title">
                        <span>{ctfData.section.title}</span>
                        <span className="accent">{ctfData.section.titleAccent} {ctfData.section.titleEnd}</span>
                    </h1>
                    <p className="ctf-hero__sub">
                        {ctfData.section.subtitle}
                    </p>
                    <div className="ctf-hero__stats">
                        <span className="ctf-hero__stat"><i className="fa fa-calendar-alt" /><strong>{ctfData.hero.date}</strong></span>
                        <span className="ctf-hero__stat"><i className="fa fa-users" />Teams of <strong>{ctfData.hero.teamSize}</strong></span>
                        <span className="ctf-hero__stat"><i className="fa fa-trophy" />Prize Pool <strong>{ctfData.hero.prizePool}</strong></span>
                        <span className="ctf-hero__stat"><i className="fa fa-clock" /><strong>{ctfData.hero.timing}</strong></span>
                        <span className="ctf-hero__stat"><i className="fa fa-signal" />{ctfData.hero.difficulty}</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
